// *******************************************************************************
// Animate Background
// *******************************************************************************

const imageText = document.querySelectorAll('.image-text');

imageText.forEach((parent) => {
  const imageTextBg = parent.querySelector('.image-text__bg-image');

  if (imageTextBg) {
    gsap.set(imageTextBg, { y: '50%', opacity: 0, rotation: 180 });

    gsap.to(imageTextBg, {
      y: '0%',
      opacity: 1,
      rotation: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: parent,
        start: 'top 70%',
        end: 'bottom 30%',
      },
    });
  }
});
